<template>
  <RevCard
    class="flex flex-row items-center gap-x-24 px-16 py-8"
    @click="onClickCopy"
  >
    <p
      class="heading-2 grow cursor-pointer overflow-hidden text-ellipsis text-left"
    >
      {{ copyValue }}
    </p>
    <RevButtonIcon
      :alternative-text="copyButtonAltText"
      :icon="copyIcon"
      variant="ghost"
      @click="onClickCopy"
    />
  </RevCard>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { RevCard } from '@ds/components/Card'
import { IconCheckLarge } from '@ds/icons/IconCheckLarge'
import { IconCopy } from '@ds/icons/IconCopy'

import type { CopyToClipboardProps } from './CopyToClipboard.types'
import { copyToClipboard } from './CopyToClipboard.util'

const {
  copyValue,
  toastTitle,
  toastMessage = '',
} = defineProps<CopyToClipboardProps>()

const { openSuccessToast } = useTheToast()

const hasCopied = ref<boolean>(false)

const copyIcon = computed(() => (hasCopied.value ? IconCheckLarge : IconCopy))

async function onClickCopy() {
  try {
    await copyToClipboard(copyValue)
    hasCopied.value = true

    openSuccessToast({
      title: toastTitle,
      content: toastMessage,
      name: 'toast_copy_clipboard',
    })
  } catch (e) {
    // This can occur if e.g. the user has no permission to copy.
    // Considering this to be very rare occurance, hence no handling here.
  }
}
</script>
